import { Component, ComponentOptions } from "../component";
import { UserComponent } from "../userComponent";
import addExpressionView from "./addExpression.view";
import addGroupView from "./addGroup.view";
import filterView from "./filter.view";
import { ll } from "../../../core/ll";
import * as z from "../../..";
import _ from "lodash";
import GridTabPopUp from "ServicePro/Scripts/app/scheduler/schedulerplus/userGridTabPopUp/userGridTabPopUp";

export interface FilterOptions extends ComponentOptions {
    userInfo?: Component[];
    links?: Component[];
    topUtilities?: Component[];
    bottomUtilities?: Component[];
    autoCompleteDataSource?: any;
}

export class Filter extends UserComponent {

    expressionClicked: number = 0;
    groupClicked: number = 0;
    private entitiesToFilter = ["Appointment", "Order", "AssignedTech", "PreferredTech", "Customer", "Site" ]
    techTrackerEnabled: boolean;
    autoCompleteDataSource: kendo.data.DataSource = new kendo.data.DataSource();
    filterUpdated: boolean = false;
    gridTabPopUp: GridTabPopUp;


    constructor(gridTabPopUp: GridTabPopUp) {
        super(()=> filterView(), {});
        this.gridTabPopUp = gridTabPopUp;
    }

    initialize(){
        this.bindEvents();
        z.bindLocalizedLanguage({ container: this.getContainer() });
        var columnData = this.returnColumns(this.entitiesToFilter);
        this.autoCompleteDataSource.data(columnData);
        this.autoCompleteDataSource.sort({field: "ColumnName", dir: "asc"});
        this.autoCompleteDataSource.group({field: "group"});
    }

    bindEvents() {
        var me = this;

        me.get(`#add-expression-button0`).click(function () {
            me.expressionClicked += 1;
            me.renderNewExpressionView(me, me.get(`#ExpressionContainer_0`));
            me.onFilterUpdated();
        });
        me.get(`#add-group-button0`).click(function () {
            me.groupClicked += 1;
            // render new group view in promise since we need to wait before binding
            me.renderNewGroupView(me);
            // Adding a new group view should automatically add a blank filter to the new group (so this just does the same thing that clicking Add Expression would do)
            me.expressionClicked += 1;
            me.renderNewExpressionView(me, $(`#ExpressionContainer_${me.groupClicked}`));
            me.onFilterUpdated();
        });
        me.get(`#AndOrToggle0`).click(function () {
            me.onFilterUpdated();
        });
    }

    public bindNewGroupView(id: string, context: any){
        $(`#${id}`).click(function () {
            context.groupClicked += 1;
            context.renderNewGroupView(context);
            // Adding a new group view should automatically add a blank filter to the new group (so this just does the same thing that clicking Add Expression would do)
            context.expressionClicked += 1;
            context.renderNewExpressionView(context, $(`#ExpressionContainer_${context.groupClicked}`));
            context.onFilterUpdated();
        });
        $(`#add-expression-button${context.groupClicked}`).click(function () {
            context.expressionClicked += 1;
            context.renderNewExpressionView(context, $(`#ExpressionContainer_${this.id.split("add-expression-button")[1]}`));
            context.onFilterUpdated();
        });
        $(`#AndOrToggle${context.groupClicked}`).click(function () {
            context.onFilterUpdated();
        });
    }


    public initializeFilterAndMatchDataTypes(id: string, type?: string ) {
        let dataArray = [];
        var filterType = $(`#FilterType${id}`);
        var filterValue = $(`#FilterValueInput${id}`);
        var dateTimeFilterValue = $(`#DateTimeFilterValueContainer${id}`);
        var dateTimeFilterValueInput = $(`#DateTimeFilterValueInput${id}`);

        dateTimeFilterValueInput.data("kendoDateTimePicker").value(null);
        filterValue.val("");

        filterValue.show();
        filterValue.attr("required", "true");
        dateTimeFilterValue.hide();
        dateTimeFilterValueInput.removeAttr("required");

        switch (type) {
            case "DateTime":
                filterValue.hide();
                filterValue.removeAttr("required");
                dateTimeFilterValue.show();
                dateTimeFilterValueInput.attr("required", "true");
                dataArray = [
                    { Text: ll("FilterableDateGte"), Value: "gte" },
                    { Text: ll("FilterableDateGt"), Value: "gt" },
                    { Text: ll("FilterableDateEq"), Value: "eq" },
                    { Text: ll("FilterableDateLt"), Value: "lt" },
                    { Text: ll("FilterableDateLte"), Value: "lte" }];
                break;
            case "String":
                dataArray = [
                    { Text: ll("FilterableStartswith"), Value: "startswith" },
                    { Text: ll("FilterableContains"), Value: "contains" },
                    { Text: ll("FilterableDoesnotcontain"), Value: "doesnotcontain" },
                    { Text: ll("FilterableEndswith"), Value: "endswith" },
                    { Text: ll("FilterableEq"), Value: "eqstring" },
                    { Text: ll("FilterableNeq"), Value: "neqstring" },
                    { Text: ll("IsBlank"), Value: "isnull" },
                    { Text: ll("IsNotBlank"), Value: "isnotnull" }];
                break;
            case "Int32":
            case "Int16":
            case "Byte":
            case "Currency":
            case "Decimal":
            case "Single":
                dataArray = [
                    { Text: ll("FilterableGte"), Value: "gte" },
                    { Text: ll("FilterableGt"), Value: "gt" },
                    { Text: ll("FilterableEq"), Value: "eq" },
                    { Text: ll("FilterableLt"), Value: "lt" },
                    { Text: ll("FilterableLte"), Value: "lte" },
                    { Text: ll("IsBlank"), Value: "isnull" },
                    { Text: ll("IsNotBlank"), Value: "isnotnull" }];
                break;
            case "Custom":
                break;
            case "Boolean":
                filterValue.hide();
                filterValue.removeAttr("required");
                dataArray =  [
                    { Text: ll("IsTrue"), Value: "istrue" },
                    { Text: ll("IsFalse"), Value: "isfalse" }];
                break;
            default:
                dataArray =  [{Text: ll("ChooseProperty"), Value: ""}];
        }
        filterType.data("kendoDropDownList").setDataSource(new kendo.data.DataSource({ data: dataArray }));
        filterType.data("kendoDropDownList").select(0);
    }

    public bindNewExpression(id: string, context: any) {
        let me = this;
        var fieldSearch = $(`#FieldSearch${id}`);
        var filterType = $(`#FilterType${id}`);
        var filterValue = $(`#FilterValueInput${id}`);
        var dateTimeFilterValueContainer = $(`#DateTimeFilterValueContainer${id}`);
        var dateTimeFilterValue = $(`#DateTimeFilterValueInput${id}`);

        fieldSearch.attr("required", "true");
        me.initializeFilterAndMatchDataTypes(id);

        if (!fieldSearch.data("kendoAutoComplete")) {
            z.controls.autoComplete({
                id: `FieldSearch${id}`,
                noSelect: true,
                placeholder: z.ll("New"),
                dataTextField: "ColumnName",
                dataSource: context.autoCompleteDataSource,
                templateJSON: {
                    columns: [
                        {
                            width: 180,
                            data: "ColumnName",
                            headerLabel: "Field",
                        }
                    ],
                },
                change: function () {
                    var dataItem = this.value();
                    if(!dataItem) {
                        // input was cleared, reset filter
                        me.initializeFilterAndMatchDataTypes(id);
                    }
                    me.onFilterUpdated();
                }
            });
            // This will ensure that when you give focus to the auto complete when its empty, that it will show the full set of data without requiring the user to type anything.
            fieldSearch.tie("focus", function () {
                fieldSearch.data("kendoAutoComplete").search("");
            });

            fieldSearch.data("kendoAutoComplete").bind("select", function (e) {
                var dataItem = this.dataItem(e.item.index());
                let type = dataItem.type;
                me.initializeFilterAndMatchDataTypes(id, type);
                me.onFilterUpdated();
            });

            filterType.data("kendoDropDownList").bind("select", function (e) {
                var dataItem = this.dataItem(e.item.index());
                let filter = dataItem.Value;
                if (filter == 'isnull' || filter == 'isnotnull' || filter == 'istrue' || filter == 'isfalse') {
                    filterValue.hide();
                    filterValue.removeAttr("required");
                    dateTimeFilterValue.removeAttr("required");
                } else if (dateTimeFilterValueContainer.css('display') == 'none') {
                    filterValue.show();
                    filterValue.attr("required", "true");
                    dateTimeFilterValue.removeAttr("required");
                } else {
                    filterValue.removeAttr("required");
                    dateTimeFilterValue.attr("required", "true");
                }
                me.onFilterUpdated();
            });

            filterValue.bind("input", function () {
                me.onFilterUpdated();
            });

            dateTimeFilterValue.data("kendoDateTimePicker").bind("change", function () {
                me.onFilterUpdated();
            });
        }
    }


    public renderNewGroupView(me: any){
        addGroupView(me.groupClicked).render(me.get("#FilterContainer"))
        z.bindLocalizedLanguage({ container: me.getContainer() });

        // bind new buttons
        me.bindNewGroupView(`add-group-button${me.groupClicked}`, me)
        me.bindRemoveGroupButton(me.groupClicked, me)
    }

    public renderNewExpressionView(me: any, location:any){
        addExpressionView(me.expressionClicked).render(location);
        me.bindNewExpression(me.expressionClicked, me);
        me.bindRemoveExpressionButton(me.expressionClicked, me);
    }

    public bindRemoveExpressionButton(context: any, me: any){
        $(`#RemoveExpression${context}`).click(function () {
            $(`#ExpressionDetailsContainer_${context}`).detach();
            me.onFilterUpdated();
        });
    }

    public bindRemoveGroupButton(context: any, me: any){
        $(`#RemoveGroup${context}`).click(function () {
            $(`#GroupContainer_${context}`).detach();
            me.onFilterUpdated();
        });
    }

    onFilterUpdated() {
        let me = this;
        me.filterUpdated = true;
        me.gridTabPopUp.enableOrDisableButtons();
    }

    public setupExistingFilter(filterDefinitionJson: string)
    {
        let me = this;

        if (filterDefinitionJson) {
            let filterDefinition = JSON.parse(filterDefinitionJson);

            _.forEach(filterDefinition.Groups as any[], (group, groupIndex) => {
                if (groupIndex > 0) {
                    me.groupClicked += 1;
                    me.renderNewGroupView(me);
                }
                $(`[id$='AndOrToggle${me.groupClicked}']`).prop("checked", group.Operator === "and");
                _.forEach(group.Expressions as any[], (expression, expressionIndex) => {
                    let inputBoxHidden = (expression.Type === "isnull" || expression.Type === "isnotnull" || expression.Type === "istrue" || expression.Type === "isfalse");
                    me.expressionClicked += 1;
                    if (groupIndex === 0) {
                        me.renderNewExpressionView(me, me.get(`#ExpressionContainer_${me.groupClicked}`));
                    } else {
                        me.renderNewExpressionView(me, $(`#ExpressionContainer_${me.groupClicked}`));
                    }
                    if (expression.Field) {
                        let autoComplete = $(`#FieldSearch${me.expressionClicked}`).data("kendoAutoComplete") as any;
                        let selectedItem = this.autoCompleteDataSource.data().find((item: any) => item.selectPath === expression.Field);
                        autoComplete.value(selectedItem.ColumnName);
                        autoComplete.selectedDataItem = selectedItem;
                        me.initializeFilterAndMatchDataTypes(me.expressionClicked.toString(), selectedItem.type);
                    }
                    if (expression.Type) {
                        $(`#FilterType${me.expressionClicked}`).data("kendoDropDownList").value(expression.Type);
                        if (inputBoxHidden) {
                            $(`#FilterValueInput${me.expressionClicked}`).hide();
                            $(`#FilterValueInput${me.expressionClicked}`).removeAttr("required");
                        }
                    }
                    if ($(`#DateTimeFilterValueContainer${me.expressionClicked}`).css('display') == 'none') {
                        if (!inputBoxHidden) {
                            $(`#FilterValueInput${me.expressionClicked}`).val(expression.Value);
                        }
                    } else {
                        $(`#DateTimeFilterValueInput${me.expressionClicked}`).data("kendoDateTimePicker").value(new Date(expression.Value));
                    }
                });
            });
        }

        // Once we're done with all of the initial set up, reset filterUpdated equal to false, to ensure that its not set to true until a user makes a change
        me.filterUpdated = false;
    }

    returnColumns(entities: string[]) {
        const columns = []
        entities.forEach((entity) => {
            var schema = null;
            if (entity !== "AssignedTech" && entity !== "PreferredTech") {
                schema = z.schemas[entity];
            } else {
                let stEntity = "ServiceTech";
                schema =  z.schemas[stEntity];
            }
            var udfs = $.grep(z.user.companyData.UserDefinedFields, function (data) {
                if (entity === "AssignedTech" || entity === "PreferredTech") {
                    return data.TableName == "ServiceTech";
                }
                return data.TableName == entity;
            });
            var selectPath = "";
            if (entity === "Customer") {
                selectPath = "Order/Customer";
            } else if (entity === "Site") {
                selectPath = "Order/Site";
            } else if (entity !== "Appointment") {
                selectPath = entity;
            }

            Object.keys(schema.Properties).forEach((property) => {
                let type = schema.Properties[property].Type;
                if (property.toLowerCase() == "id") {
                    columns.push(
                        {
                            ColumnName: entity+property,
                            group: entity,
                            type: type,
                            selectPath: selectPath === "" ? property : `${selectPath}/${property}`
                        }
                    );
                }
                else {
                    columns.push(
                        {
                            ColumnName: property,
                            group: entity,
                            type: type,
                            selectPath: selectPath === "" ? property : `${selectPath}/${property}`
                        }
                    );
                }
            });

            udfs.forEach((udf) => {

               let type = "";
               switch (udf.Type) {
                case "INT":
                case "ENUM":
                    type = "Int32";
                    break;
                case "FLOAT":
                    type = "Decimal";
                    break;
                case "CHECKBOX":
                    type = 'Boolean'
                    break;
                case "DATE":
                case "DATETIME":
                    type = "DateTime"
                    break;
                case "URL":
                case "TEXTAREA":
                case "STRING":
                    type = "String";
                    break;
                }

                columns.push(
                    {
                        ColumnName: udf.FieldName,
                        group: entity,
                        type: type,
                        selectPath: selectPath === "" ? udf.BindName : `${selectPath}/${udf.BindName}`
                    }
                );
            });
        })

        return columns;
    }

}
